// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__22frM","legacyBtn":"MutateMid_legacyBtn__2NlHo"};